module.exports = __webpack_public_path__ + "static/media/visitbrussels_7.403e01c6.jpg";